import { render } from "./SiderbarAdmin.vue?vue&type=template&id=ea7c12d0"
import script from "./SiderbarAdmin.vue?vue&type=script&lang=js"
export * from "./SiderbarAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/builds/springup/oa-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__